import React from 'react'
import { RegistroMChatAcompanhamentoPuericultura } from 'view/atendimentos/detail/soap/aside/acompanhamento-puericultura/model'

import { MCHAT_RESULTADOS } from '../model-mChatRf'
import { MChatRfRegistroListItem } from './MChatRfRegistroListItem'

interface ConsultaSeguimentoRegistroListItemProps {
  item: RegistroMChatAcompanhamentoPuericultura
  cidadaoDataNascimento: LocalDate
  isLastItem: boolean
  onPrint: (event: React.MouseEvent<HTMLButtonElement>, item: RegistroMChatAcompanhamentoPuericultura) => void
}

export function ConsultaSeguimentoRegistroListItem(props: Readonly<ConsultaSeguimentoRegistroListItemProps>) {
  const { item, cidadaoDataNascimento, isLastItem, onPrint } = props

  const { encaminhamento, title, status } = MCHAT_RESULTADOS[item.risco]

  return (
    <MChatRfRegistroListItem
      type='consulta-seguimento'
      status={status}
      title={title}
      label={`${item.pontuacao} falhou`}
      description={encaminhamento()}
      isLastItem={isLastItem}
      footerInfo={{
        atendimentoProfissionalId: item.atendimentoProfissional.id,
        dataResultado: item.dataResultado,
        lotacao: item.atendimentoProfissional.lotacao,
      }}
      onPrint={(event) => onPrint(event, item)}
      cidadaoDataNascimento={cidadaoDataNascimento}
    />
  )
}
